import store from '@/store/index';
import logger from '@/modules/Logger';

/**
 * Determines if the current browser supports audio capture during screen sharing.
 * Only Chromium-based desktop browsers support this: Chrome 74+, Edge 79+, Opera 62+.
 */
export function isScreenShareAudioSupported() {
  const browserName = store.state.uaParser.userAgentInfo?.browser?.name;
  const browserVersion = parseFloat(store.state.uaParser.userAgentInfo?.browser?.version);
  const deviceType = store.state.uaParser.userAgentInfo?.device?.type;

  // Mobile devices never support screen share audio
  if (deviceType === 'mobile' || deviceType === 'tablet') {
    return false;
  }

  const supported = (
    (browserName === 'Chrome' && browserVersion >= 74) ||
    (browserName === 'Edge' && browserVersion >= 79) ||
    (browserName === 'Opera' && browserVersion >= 62)
  );

  if (!supported) {
    logger.info(`Screen share audio not supported on ${browserName} ${browserVersion}`, {
      operation: 'webrtc:share-screen'
    });
  }

  return supported;
}
